import { antGrey, appHomeCardsWidgetTitleStyle, runwayColors } from '@/components/styles/globalStyles';
import Progress from 'antd/lib/progress';
import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { CompactFeaturesStepData } from '@/types';
import Popover from 'antd/lib/popover';
import Badge from 'antd/lib/badge';
import Space from 'antd/lib/space';

export interface FeatureCompletionBarProps {
    featuresStep?: CompactFeaturesStepData;
    compact?: boolean;
}

const COMPLETED_WORK_ITEMS_COLOR = runwayColors.statusGreen;
const PENDING_WORK_ITEMS_COLOR = antGrey.grey5;

export const FeatureCompletionWidget: React.FC<FeatureCompletionBarProps> = ({ featuresStep, compact = false }) => {
    if (!featuresStep) return null;

    const popoverContent = (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minWidth: 260, padding: 4 }}>
            <Text style={{ color: antGrey.grey7, fontSize: 14 }}>
                Feature readiness — {`${featuresStep.completedItemsCount} / ${featuresStep.totalItemsCount}`}
            </Text>
            <Badge color={COMPLETED_WORK_ITEMS_COLOR} text={`${featuresStep.completedItemsCount} completed items`} />
            <Badge color={PENDING_WORK_ITEMS_COLOR} text={`${featuresStep.pendingItemsCount} pending items`} />
        </div>
    );

    const progressBar = (
        <Progress
            type="line"
            className="widget-progress-bar"
            strokeColor={COMPLETED_WORK_ITEMS_COLOR}
            trailColor={PENDING_WORK_ITEMS_COLOR}
            percent={featuresStep.percentFeatureComplete}
            showInfo={false}
            strokeLinecap="butt"
        />
    );

    if (compact) {
        return (
            <Space size={8} style={{ width: '100%' }}>
                <Popover content={popoverContent}>
                    <div style={{ flex: 1, minWidth: 100 }}>{progressBar}</div>
                </Popover>
                <Text style={{ fontSize: 14, color: antGrey.grey7, whiteSpace: 'nowrap' }}>
                    {`${featuresStep.completedItemsCount} / ${featuresStep.totalItemsCount}`}
                </Text>
            </Space>
        );
    }
    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <Text style={{ ...appHomeCardsWidgetTitleStyle }}>Feature readiness</Text>
                <Text
                    style={{ ...appHomeCardsWidgetTitleStyle }}
                >{`${featuresStep.completedItemsCount} / ${featuresStep.totalItemsCount}`}</Text>
            </div>
            <Popover content={popoverContent}>
                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                        height: 22,
                    }}
                >
                    <div
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                        }}
                    >
                        {progressBar}
                    </div>

                    {/* leaving this for when we want to consider fixes in the graph */}

                    {/* <Progress
                        type="line"
                        className="widget-progress-bar"
                        strokeColor={PENDING_WORK_ITEMS_COLOR}
                        percent={pendingWorkItemsPercent + pendingFixesPercent}
                        showInfo={false}
                        strokeLinecap="butt"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            transform: 'scaleX(-1)',
                        }}
                        success={{ percent: pendingFixesPercent, strokeColor: PENDING_FIXES_COLOR }}
                    /> */}
                </div>
            </Popover>
        </div>
    );
};
